import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Home } from "./Screens/Home/Home";
import React from "react";
import { Conocenos } from "./Screens/Home/Components/Conocenos/Conocenos";

function App() {
  return (
    <Router basename="/visnu">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/2" component={Conocenos} />
      </Switch>
    </Router>
  );
}

export default App;
